export default {
  common: {
    home: 'Home',
    about: 'About',
    search: 'Search',
    loading: 'Loading...',
    noData: 'No Data',
    loadMore: 'Load More',
    backTop: 'Back to Top',
    articles: 'Articles',
    tags: 'Tags',
    feedback: 'Feedback',
    all: 'All',
    confirm: 'Confirm',
    cancel: 'Cancel',
    submit: 'Submit',
    reset: 'Reset',
    prev: 'Previous',
    next: 'Next',
    page: 'Page {n}',
    total: '{n} articles',
    sortBy: 'Sort',
    filterBy: 'Filter',
    newest: 'Newest',
    hottest: 'Hottest',
    notFound: 'Page Not Found',
    notFoundDesc: 'The page you are looking for does not exist',
    backHome: 'Back to Home',
    language: 'Language',
  },
  nav: {
    nba: 'NBA',
    cba: 'CBA',
    international: 'International',
    equipment: 'Equipment',
    training: 'Training',
    culture: 'Culture',
  },
  news: {
    latest: 'Latest News',
    hot: 'Hot News',
    featured: 'Featured',
    related: 'Related News',
    views: 'views',
    source: 'Source',
    publishTime: 'Published',
    articleList: 'Articles',
  },
  feedback: {
    title: 'Feedback',
    name: 'Name',
    email: 'Email',
    message: 'Message',
    namePlaceholder: 'Enter your name',
    emailPlaceholder: 'Enter your email',
    messagePlaceholder: 'Enter your feedback',
    submitSuccess: 'Thank you for your feedback!',
    submitFail: 'Submission failed, please try again later',
    nameRequired: 'Name is required',
    emailRequired: 'Email is required',
    emailInvalid: 'Invalid email format',
    messageRequired: 'Message is required',
  },
  about: {
    title: 'About Us',
    siteName: 'Site Name',
    domain: 'Domain',
    category: 'Category',
    email: 'Contact Email',
    description: 'Description',
    descContent: 'This site is a B530CF network sub-site, content is automatically published after unified collection and review by the hub',
  },
  tag: {
    title: 'Tag Cloud',
    articlesWithTag: 'Articles with Tag',
  },
  site: {
    name: 'Basketball World',
    slogan: 'Global Basketball News at Your Fingertips',
    copyright: '© 2026 Basketball World. All rights reserved.',
  },
}
